/**
 *
 * @param {string} divId id of container for widget in DOM model
 * @param {PaymentIframeParams} widgetParams The parameters
 */
export const initializationMifinityWidget = (id, testMode, params) =>
  widget(IFRAME_SRC, testMode)(id, params, WIDTH, HEIGHT);

var iframes = {};

const IFRAME_SRC = 'iframe/index.html';
const IFRAME_HEIGH_PX = 667;
const WIDTH = '375px';
const HEIGHT = `${IFRAME_HEIGH_PX}px`;

function parseJson(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return;
  }
}

function hashCode(str) {
  var res = 0,
    len = str.length;
  for (var i = 0; i < len; i++) {
    res = res * 31 + str.charCodeAt(i);
  }
  return res;
}

function widget(entryPage, testMode) {
  const IFRAME_DOMAIN = testMode ? 'https://demo.mifinity.com/' : 'https://secure.mifinitypay.com/';

  /*
   * @name createDomElementIframe
   * @param       {string}    src         Iframe source url.
   * @param       {string}    width       Iframe width in pixels.
   * @param       {string}    height      Iframe width in pixels.
   * @param       {string}    border      iframe border style (css property)
   * @returns     {Element}   newIframe   The created iframe.
   */
  function createDomElementIframe(src, name, height, border) {
    var el = document.createElement('iframe');
    el.setAttribute('src', src);
    el.setAttribute('name', name);
    el.setAttribute('width', '100%');
    el.setAttribute('height', '100%');
    el.setAttribute('class', '__paymentIframe_iframe');
    el.setAttribute(
      'style',
      `border: ${border}; box-sizing: border-box; width: 1px; min-width: 100% !important; min-height: ${height};`
    );

    return el;
  }

  function createDomElementWrapForIframe(iframe, width, height) {
    var div = document.createElement('div');
    div.setAttribute('class', '__paymentIframe_container');
    div.setAttribute(
      'style',
      `width: 100%; max-width: ${width}; min-width: 310px; height:100%; margin: auto; min-height: ${height}; max-height: 700px;`
    );
    div.appendChild(iframe);

    return div;
  }

  /**
   * initialize the event exchange with the content of the iframe
   * @param {PaymentIframeParams} params parameters
   * @param {string} iframeHashId unique id of the iframe
   * @param {DOM} iframe The created iframe to send messages to.
   * @returns {Function} function for dettaching event listening
   * @private
   */
  function initEvents(params, iframeHashId, iframe) {
    var eventMethod;
    var messageEvent;

    var onEvent = function (event) {
      function runCallback(func) {
        if (typeof func == 'function') {
          window.setTimeout(() => func(), 0);
        }
      }
      if (IFRAME_DOMAIN.indexOf(event.origin) === 0 && iframe) {
        const msg = parseJson(event.data);
        if (msg && msg.id == iframeHashId) {
          if (msg.type === 'ready') {
            runCallback(params.ready);

            //here we pass params to the iframe
            if (JSON) {
              // works starting from IE8
              var expectedParams = [
                'token',
                'amount',
                'currency',
                'merchant',
                'description',
                'client',
                'nameOnCard',
              ];
              var pure_params = {};
              for (var key in expectedParams) {
                var paramName = expectedParams[key];
                if (paramName && params[paramName] && typeof params[paramName] != 'function') {
                  pure_params[paramName] = params[paramName];
                }
              }
              iframe.contentWindow.postMessage(
                JSON.stringify({ type: 'params', message: pure_params }),
                IFRAME_DOMAIN
              ); // Send message to iframe page.
            }
          } else if (msg.type === 'success') {
            runCallback(params.success);
            runCallback(params.complete);
          } else if (msg.type === 'fail') {
            runCallback(params.fail);
            runCallback(params.complete);
          } else if (msg.type === 'cancel') {
            runCallback(params.cancel);
            runCallback(params.fail);
            runCallback(params.complete);
          }
        }
      }
    };

    if (window.addEventListener) {
      eventMethod = 'addEventListener';
      messageEvent = 'message';
    } else {
      eventMethod = 'attachEvent';
      messageEvent = 'onmessage';
    }

    window[eventMethod](messageEvent, onEvent, false); // Widget window listen on message event.

    return function () {
      // On close remove Widget window Event listener.
      iframe = null;
      if (window.removeEventListener) {
        window.removeEventListener(messageEvent, onEvent, false);
      } else {
        window.detachEvent(messageEvent, onEvent);
      }
    };
  }

  /**
   * create iframe and attach to DOM
   * @param {string} id div's id
   * @param {PaymentIframeParams} params iframe's params
   * @param {string} width
   * @param {string} height
   * @return {PaymentIframeObject}
   * @private
   */
  return function showIframe(id, params, width, height) {
    const idHash = hashCode(id);
    if (iframes[idHash]) {
      iframes[idHash].close();
    }

    const el = document.getElementById(id);
    if (el == null) {
      console.error(`could not find an element with id = #${id}`);
    } else {
      var src = IFRAME_DOMAIN + entryPage;
      var border = '3px solid #eee';
      var iframe = createDomElementIframe(src, idHash, height, border);
      var div = createDomElementWrapForIframe(iframe, width, height);
      div = el.appendChild(div);

      var detachEvent = initEvents(params, idHash, iframe, div);

      /**
       * @typedef PaymentIframeObject
       * @property {function} close The function to close the sgpg iframe and detach it from DOM
       */
      var returnObject = {
        close: function () {
          if (div) {
            el.removeChild(div);
            div = null;
            iframe = null;
          }
          iframes[idHash] = undefined;
          detachEvent();
        },
      };

      iframes[idHash] = returnObject;

      return returnObject;
    }
  };
}
